import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { useState } from 'react';
import { FlexRowCenterVertical, TextP } from '../../..';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';
import { RangeFilter } from './RangeFilter';
import { OptionsFilter } from './OptionsFilter';
import { LinksFilter } from './LinksFilter';

enum FilterType {
  RANGE = 'RANGE',
  OPTIONS = 'CHECKBOX',
  LINKS = 'LINKS',
  CHECK = 'CHECK',
}

interface Props {
  type: FilterType;
  name: string;
  isMobile?: boolean;
  initialIsOpen?: boolean;
  filterData:
    | { min: number; max: number; activeMin: string; activeMax: string }
    | { links: Array<{ name: string; url: string }> }
    | { values: any[]; attribId: string };
  handleFilterChange: any;
  activeValues?: any;
  unit?: string;
}

function CategoryFilter({
  type,
  name,
  initialIsOpen = false,
  isMobile = false,
  filterData,
  handleFilterChange,
  activeValues,
  unit,
}: Props) {
  const [isOpen, setIsOpen] = useState(initialIsOpen);

  React.useEffect(() => {
    setIsOpen(initialIsOpen);
  }, [initialIsOpen]);

  const changeIsOpenState = () => {
    setIsOpen(!isOpen);
  };

  return (
    <FilterItem hasGradient={type === FilterType.LINKS} isMobile={isMobile}>
      <ItemTitleWrapper onClick={changeIsOpenState} isOpen={isOpen}>
        <ItemTitle>{name}</ItemTitle>
        <TitleIcon
          icon={isOpen ? IconType.bottomArrow : IconType.topArrow}
          width={10}
          height={8}
          viewBox="0 0 8 5"
          cursor="pointer"
          alt="šípka"
          // rotate={isOpen ? 0 : 180}
        />
      </ItemTitleWrapper>
      <FilterWrapper className={isOpen ? 'show' : ''}>
        {isOpen &&
          (type === FilterType.RANGE ? (
            <RangeFilter
              handleFilterChange={handleFilterChange}
              isOpen={isOpen}
              filterData={filterData}
              unit={unit}
              activeValues={activeValues}
            />
          ) : type === FilterType.OPTIONS ? (
            <OptionsFilter
              handleFilterChange={handleFilterChange}
              isOpen={isOpen}
              filterData={filterData}
              activeValues={activeValues}
            />
          ) : type === FilterType.LINKS ? (
            <LinksFilter isOpen={isOpen} filterData={filterData} />
          ) : null)}
      </FilterWrapper>
    </FilterItem>
  );
}

const FilterItem = styled.div<{
  isMobile: boolean | false;
  hasGradient?: boolean;
}>`
  background: ${({ theme, isMobile }) =>
    isMobile ? theme.colors.white : theme.categoryFilter.bgColor};
  padding: ${({ theme }) => theme.categoryFilter.padding};
  margin: ${({ theme }) => theme.categoryFilter.margin};
  border: ${({ theme }) => theme.categoryFilter.border};
  border-radius: ${({ theme }) => theme.categoryFilter.borderRadius};

  position: relative;
  &:after {
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 85%;
    content: '';
    background: ${({ hasGradient }) =>
      hasGradient
        ? `linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.2) 25%
    )`
        : ''};
    pointer-events: none; /* so the text is still selectable */
  }
  ${({ theme }) => theme.mediab.l1050`
    padding: ${theme.categoryFilter.mobilePadding};
    margin: ${theme.categoryFilter.mobileMargin};
    border: 0;
    border-top: ${theme.categoryFilter.border};
  `}
`;

const FilterWrapper = styled.div<{ show?: boolean }>`
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  -moz-transition: opacity 0.3s ease-in-out;
  -webkit-transition: opacity 0.3s ease-in-out;

  &.show {
    opacity: 1;
    visibility: visible;
  }
`;

const TitleIcon = styled(SvgIcon)`
  transition: transform 0.3s ease;
  fill: ${({ theme }) => theme.categoryFilter.color};
`;

const ItemTitle = styled(TextP)`
  font-size: ${rem(20)};
  font-weight: 500;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.categoryFilter.color};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(18)};
    line-height: ${rem(22)};
  `}
`;

const ItemTitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  cursor: pointer;
`;

export { CategoryFilter, FilterType };
